<div class="game-period-filters">
	<mtg-dropdown
		[formControl]="periodControl"
		variant="button"
		label="Тайм"
		[errorVisible]="false"
	>
		<mtg-dropdown-item
			*ngFor="let period of periods"
			[value]="period"
		>{{ period }} тайм</mtg-dropdown-item>
		<mtg-dropdown-item
			*ngFor="let p of overtimePeriods"
			[value]="p"
    >
      <ng-container *ngIf="p !== game.rugbyGameConfig.penaltyPeriod">
        {{ p - game.rugbyGameConfig.periodsCount }} доп. тайм
      </ng-container>
      <ng-container *ngIf="p === game.rugbyGameConfig.penaltyPeriod">
        Штрафные удары
      </ng-container>
    </mtg-dropdown-item>
	</mtg-dropdown>
	<mtg-dropdown
		[formControl]="positionControl"
		label="Позиция"
		variant="button"
		[errorVisible]="false"
	>
		<mtg-dropdown-item
			*ngFor="let value of positions"
			[value]="value"
		>{{ value | localization: positionLocalization }}</mtg-dropdown-item>
	</mtg-dropdown>
	<div class="search">
		<mtg-text-field
			size="sm"
			placeholder="Искать игрока..."
			[formControl]="query"
			trailingIcon="icons-search"
		></mtg-text-field>
	</div>
</div>

<mtg-table>
	<mtg-table-header-row mtgSticky="top" [top]="headerHeight">
		<mtg-table-identity-col>
			<div class="team">
				<div class="logo">
					<a [routerLink]="getTeamRoute(team.id)">
						<img [src]="team.logo.path" *ngIf="team.logo.path" [alt]="team.name"/>
						<div [class]="team.getEmptyLogoClass()" *ngIf="!team.logo.path"></div>
					</a>
				</div>
				<div class="name">
					<a [routerLink]="getTeamRoute(team.id)">{{ team.name }}</a>
				</div>
			</div>
		</mtg-table-identity-col>
		<mtg-table-col-group title="Набранные очки">
			<mtg-table-col>попытки</mtg-table-col>
      <mtg-table-col>реализации</mtg-table-col>
      <mtg-table-col>% реализации</mtg-table-col>
			<mtg-table-col>дроп-голы</mtg-table-col>
      <mtg-table-col>штрафные удары</mtg-table-col>
      <mtg-table-col>% штрафных ударов</mtg-table-col>
      <mtg-table-col>всего</mtg-table-col>
		</mtg-table-col-group>
		<mtg-table-col-group title="Расширенная статистика">
      <mtg-table-col>захваты</mtg-table-col>
      <mtg-table-col>удары ногой в поле</mtg-table-col>
      <mtg-table-col>удары ногой в аут</mtg-table-col>
      <mtg-table-col>забеги</mtg-table-col>
      <mtg-table-col>жёлтые карточки</mtg-table-col>
      <mtg-table-col>красные карточки</mtg-table-col>
      <mtg-table-col>+/-</mtg-table-col>
      <mtg-table-col>игровое время</mtg-table-col>
		</mtg-table-col-group>
	</mtg-table-header-row>
	<mtg-table-row>
		<mtg-table-identity-col>
			<div class="total-title">
				<mtg-svg-icon icon="icons-rugby"></mtg-svg-icon>
				Всего
			</div>
		</mtg-table-identity-col>
    <mtg-table-col-group title="Набранные очки">
      <mtg-table-col>{{ getTotal('tries') }}</mtg-table-col>
      <mtg-table-col>
        {{ getTotal('conversionGoals') }}
      </mtg-table-col>
      <mtg-table-col>{{ getPercent(getTotal('conversionGoals'), getTotal('conversionKicks')) }}%</mtg-table-col>
      <mtg-table-col>
        {{ getTotal('dropGoals') }}
      </mtg-table-col>
      <mtg-table-col>
        {{ getTotal('penaltyGoals') }}
      </mtg-table-col>
      <mtg-table-col>{{ getPercent(getTotal('penaltyGoals'), getTotal('penaltyKicksOnGoal')) }}%</mtg-table-col>
      <mtg-table-col>{{ getTotal('points') }}</mtg-table-col>
    </mtg-table-col-group>
    <mtg-table-col-group title="Расширенная статистика">
      <mtg-table-col>{{ getTotal('tackles') }}</mtg-table-col>
      <mtg-table-col>{{ getTotal('footFieldShots') }}</mtg-table-col>
      <mtg-table-col>{{ getTotal('footOutShots') }}</mtg-table-col>
      <mtg-table-col>{{ getTotal('runs') }}</mtg-table-col>
      <mtg-table-col>{{ getTotal('yellowCards') }}</mtg-table-col>
      <mtg-table-col>{{ getTotal('redCards') }}</mtg-table-col>
      <mtg-table-col>
        {{ game.team.id === team.id ? game.teamScore - game.competitorTeamScore : game.competitorTeamScore - game.teamScore }}
      </mtg-table-col>
      <mtg-table-col></mtg-table-col>
    </mtg-table-col-group>
	</mtg-table-row>
	<mtg-table-row *ngFor="let user of players; trackBy: identify">
		<mtg-table-identity-col>
			<div class="number">{{ user.gameUserNumber || '–' }}</div>
			<div class="photo">
				<a [routerLink]="getUserProfileRoute(user)">
					<ng-container *ngIf="!user.tournamentTeamUser.id">
						<img [src]="user.teamUser.user.photo.path"
								 *ngIf="user.teamUser.user.photo.path"
								 class="circle-image"/>
						<div class="empty-photo" *ngIf="!user.teamUser.user.photo.path">{{ user.teamUser.user.initials }}</div>
					</ng-container>
					<ng-container *ngIf="user.tournamentTeamUser.id">
						<img [src]="user.tournamentTeamUser.leaguePlayer.photo.path"
								 *ngIf="user.tournamentTeamUser.leaguePlayer.photo.path"
								 class="circle-image"/>
						<div class="empty-photo" *ngIf="!user.tournamentTeamUser.leaguePlayer.photo.path">{{ user.tournamentTeamUser.leaguePlayer.initials }}</div>
					</ng-container>
				</a>
			</div>
			<div class="info">
				<a [routerLink]="getUserProfileRoute(user)">
					<ng-container *ngIf="user.tournamentTeamUser.id">
						<div class="name">{{ user.tournamentTeamUser.leaguePlayer.shortName }}</div>
					</ng-container>
					<ng-container *ngIf="!user.tournamentTeamUser.id">
						<div class="name">{{ user.teamUser.user.shortName }}</div>
					</ng-container>
					<div class="text-muted">{{ user.teamUser.user.rugbyProfile.position | localization: positionLocalization }}</div>
				</a>
			</div>
		</mtg-table-identity-col>
    <mtg-table-col-group title="Набранные очки">
      <mtg-table-col>{{ getUserStatistic(user.id, 'tries') }}</mtg-table-col>
      <mtg-table-col>
        {{ getUserStatistic(user.id, 'conversionGoals') }}
      </mtg-table-col>
      <mtg-table-col>
        {{ getPercent(getUserStatistic(user.id, 'conversionGoals'), getUserStatistic(user.id,'conversionKicks')) }}%
      </mtg-table-col>
      <mtg-table-col>
        {{ getUserStatistic(user.id, 'dropGoals') }}
      </mtg-table-col>
      <mtg-table-col>
        {{ getUserStatistic(user.id, 'penaltyGoals') }}
      </mtg-table-col>
      <mtg-table-col>
        {{ getPercent(getUserStatistic(user.id, 'penaltyGoals'), getUserStatistic(user.id, 'penaltyKicksOnGoal')) }}%
      </mtg-table-col>
      <mtg-table-col>{{ getUserStatistic(user.id, 'points') }}</mtg-table-col>
    </mtg-table-col-group>
    <mtg-table-col-group title="Расширенная статистика">
      <mtg-table-col>{{ getUserStatistic(user.id, 'tackles') }}</mtg-table-col>
      <mtg-table-col>{{ getUserStatistic(user.id, 'footFieldShots') }}</mtg-table-col>
      <mtg-table-col>{{ getUserStatistic(user.id, 'footOutShots') }}</mtg-table-col>
      <mtg-table-col>{{ getUserStatistic(user.id, 'runs') }}</mtg-table-col>
      <mtg-table-col>{{ getUserStatistic(user.id, 'yellowCards') }}</mtg-table-col>
      <mtg-table-col>{{ getUserStatistic(user.id, 'redCards') }}</mtg-table-col>
      <mtg-table-col>{{ userEfficiency[user.id] || 0 }}</mtg-table-col>
      <mtg-table-col>{{ userMinutes[user.id] || 0 }}</mtg-table-col>
    </mtg-table-col-group>
	</mtg-table-row>
</mtg-table>

